import script from "./GovernanceVote.vue?vue&type=script&setup=true&lang=js"
export * from "./GovernanceVote.vue?vue&type=script&setup=true&lang=js"

import "./GovernanceVote.vue?vue&type=style&index=0&id=3b454676&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b454676"]])

export default __exports__